module.exports = __webpack_public_path__ + "img/jimeng_grey.ad57c8b4.png";